export default __webpack_public_path__ + "static/media/outputs_outcomes_icon.d4703577.svg";